export function sanitizeSearchFilter(value: string) {
    return value.trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f\s]/g, ''); // remove accents and spaces
}